import * as React from 'react';
import ButtonComponent from '../../../components/UI/Button/Button.component';
import { USER } from '../../../constants/user.constants';

/**
 * Deletes a user account.
 *
 * @param {Object} props - The props object.
 * @param {Function} props.onClick - The click event handler for the delete button.
 *
 * @return {ReactElement} - The ButtonComponent with the delete account functionality.
 */
const DeleteAccount = ({ onClick }: { onClick: any }): React.ReactElement => {
  return (
    <ButtonComponent variant="primary" onClick={onClick}>
      {USER.DELETE_ACCOUNT}
    </ButtonComponent>
  );
};

export default DeleteAccount;
